import { Component, Input } from '@angular/core';

@Component({
  selector: 'fca-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class Page {
  @Input() title?: string = '';
  @Input() isVisible = true;
}
